module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAZCAYAAADwkER/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAeSURBVHgBxcRBEQAAEAFAcz0vlSAiooV9LMT3oQYFTIICz2MJ1+UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./images/border_left.png
// module id = 64
// module chunks = 0